module.exports = __webpack_public_path__ + "static/media/people.66eb4cfb.svg";